import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function fetchClassificationDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'classification/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export function fetchClassificationForEdit(app, params) {
  const { id } = params;
  const docType = DocType.CLASSIFICATION;
  return common.getDoc(app, { id, docType });
}

export function deleteClassification(app, params) {
  const { id } = params;
  return common.deleteDoc(app, {
    id: id,
    docType: DocType.CLASSIFICATION
  });
}


export function saveClassification(app, dataToSave) {
  const { user = {}, data } = dataToSave;
  let classificationData = {
    doc_type: DocType.CLASSIFICATION,
    active: util.toBoolean(data.active),
    name: util.toStringText(data.name),
    short_name: util.toStringText(data.short_name),
    display_name: util.toStringText(data.display_name),
    parent_id: data.parent_id,
    is_alternate_class: util.toBoolean(data.is_alternate_class),
    is_facet_class: util.toBoolean(data.is_facet_class),
    is_department: util.toBoolean(data.is_department),
    image_thumb: data.image_thumb,
    image_url: util.toStringText(data.image_url)
  };

  return common.saveDoc(app, { 
    source: data,
    doc: classificationData,
    user
  });
}


export function fetchClassificationById(app, params) {
  const { id } = params;
  const docType = DocType.CLASSIFICATION;
  return common.getDoc(app, { id, docType });
}
